import request from './../utils/request'

/**
 * 获取 首页MPM
 */
export const getHomeMpm = () => {
  return request({
    url: '/home-mpm',
    method: 'get'
  })
}

/**
 * 获取 首页布局
 */
export const getHomeLayout = () => {
  return request({
    url: '/home-layout',
    method: 'get'
  })
}

/**
 * 获取 Epg
 */
export const getMyTvChannels = () => {
  return request({
    url: `/mytv-channels?_t=${new Date().getTime()}`,
    method: 'get'
  })
}


/**
 * InstantMessage列表
 */
export const getInstantMessage = () => {
  return request({
    url: '/instant-message',
    method: 'get'
  })
}

/**
 * InstantMessage已阅
 */
export const readInstantMessage = (data) => {
  return request({
    url: `/instant-message/read/${data.unique_id}`,
    method: 'put'
  })
}

export const qrcodeApproval = (id) => {
  return request({
    url: `/qrcode/approval/${id}`,
    method: 'get'
  })
}

export const qrcodeStat = (data) => {
  return request({
    url: `/qrcode/stat/${data.application_id}`,
    method: 'put',
    data
  })
}
